// removed by extract-text-webpack-plugin
module.exports = {"container":"v1LS","wrapper":"_3Bos","contentContainer":"_2phQ","title":"_3a9S","description":"iY8z","button":"_1E6e"};


//////////////////
// WEBPACK FOOTER
// ./src/components/JobDescription/Hero/styles.scss
// module id = 463
// module chunks = 0